const API_KEY = "a474e82615f14a20949ef2f53338569d";
const CURRENT_WEATHER = `https://api.weatherbit.io/v2.0/current?city=Kathmandu,NP&key=${API_KEY}`;

export { API_KEY, CURRENT_WEATHER };
